import React, {Component} from 'react'
import PropTypes from "prop-types";
import Error from "../single_components/Error";
import Select from "react-select";
import {authenticationService} from "../../services/AuthenticationService";

class IndicationRequest extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
        }
    }
    componentDidMount() {
        let {entry,t}=this.props
        if(!entry.patient_indication){
            this.onclickIndication("patient_indication", t('patient_boarding.Idiopathic_non_cancer'))
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    onclickIndication(name,value){
        this.props.onValueChange(name, value)
        if(name !=="I_other"){
            this.props.onValueChange("other_patient_type_indication", "")
        }
    }

    render() {
        let {t} = this.props

        let {entry}= this.state

        return (
            <div className={'patientsFormBoxes'}>

                <div className={'patientsFormRow'}>
                    <div className={'inputSlots'}>
                        <label className={'infoLabel'}>{t('patient_boarding.Indication')}</label>
                        <select className={'selectBox'} id="med_condition" name="med_condition" value={entry.patient_indication}
                                onChange={(event) => this.onclickIndication("patient_indication", event.target.value)}>
                            <option value={"BehavioralDisturbance"}>{t('patient_boarding.BehavioralDisturbance')}</option>
                            <option value={"BehavioralDisturbance2"}>{t('patient_boarding.BehavioralDisturbance2')}</option>
                            <option value={t('patient_boarding.Glaucoma')}>{t('patient_boarding.Glaucoma')}</option>
                            <option value={t('patient_boarding.Gastro_Crohns_disease')}>{t('patient_boarding.Gastro_Crohns_disease')}</option>
                            <option value={t('patient_boarding.Gastro_Enterocolitis')}>{t('patient_boarding.Gastro_Enterocolitis')}</option>
                            <option value={t('patient_boarding.Idiopathic_non_cancer')}>{t('patient_boarding.Idiopathic_non_cancer')}</option>
                            <option value={t('patient_boarding.Infectious_diseases')}>{t('patient_boarding.Infectious_diseases')}</option>
                            <option value={t('patient_boarding.Neurology_adult')}>{t('patient_boarding.Neurology_adult')}</option>
                            <option value={t('patient_boarding.Neurology_Gilles')}>{t('patient_boarding.Neurology_Gilles')}</option>
                            <option value={t('patient_boarding.Neurology_Juvenile')}>{t('patient_boarding.Neurology_Juvenile')}</option>
                            <option value={t('patient_boarding.Neurology_Parkinson')}>{t('patient_boarding.Neurology_Parkinson')}</option>
                            <option value={t('patient_boarding.Neurology_refractory')}>{t('patient_boarding.Neurology_refractory')}</option>
                            <option value={t('patient_boarding.Oncology_symptom')}>{t('patient_boarding.Oncology_symptom')}</option>
                            <option value={t('patient_boarding.Oncology_chemotherapy')}>{t('patient_boarding.Oncology_chemotherapy')}</option>
                            <option value={t('patient_boarding.Palliative_care')}>{t('patient_boarding.Palliative_care')}</option>
                            <option value={t('patient_boarding.Psychiatry_PTSD')}>{t('patient_boarding.Psychiatry_PTSD')}</option>
                            <option value={t('patient_boarding.Alzheimer')}>{t('patient_boarding.Alzheimer')}</option>
                            <option value={t('patient_boarding.other')}>{t('patient_boarding.other')}</option>
                        </select>
                    </div>

                    <div className={'inputSlots'} style={{display: entry.patient_indication===t('patient_boarding.other') ?'block': 'none' }}>
                        <label className={'infoLabel'}>{t('patient_boarding.enter_indication')}</label>
                        <input type="text"  name="country" className={'inputBoxStyle'} defaultValue={entry.other_patient_type_indication}
                               onChange={(event) => this.props.onValueChange("other_patient_type_indication", event.target.value)}/>
                    </div>
                </div>




            </div>

        )
    }
}

IndicationRequest.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default IndicationRequest;
